function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import ThirdStep from "./ClaimSteps/ThirdStep";
import FirstStep from "./ClaimSteps/FirstStep";
import MdArrowBack from "@meronex/icons/ios/MdArrowBack";
import GrClose from "@meronex/icons/gr/GrClose";
import SecondStep from "./ClaimSteps/SecondStep";
import FourthStep from "./ClaimSteps/FourthStep";
import FifthStep from "./ClaimSteps/FifthStep";
import MiniSurvey from "./MiniSurvey";
import BsArrowLeft from "@meronex/icons/bs/BsArrowLeft";
import { isRewardsVisible } from "../../../utils/routing";
import SixthStep from "./ClaimSteps/SixthStep";
import SeventhStep from "./ClaimSteps/SeventhStep";
import EightStep from "./ClaimSteps/EightStep";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function KYCModal(_ref) {
  var visible = _ref.visible,
    onClick = _ref.onClick,
    userAccountSummary = _ref.userAccountSummary,
    getUserAccountSummary = _ref.getUserAccountSummary,
    closeKYCModal = _ref.closeKYCModal,
    step = _ref.step,
    error = _ref.error,
    showError = _ref.showError,
    setStep = _ref.setStep,
    rewardTypeSelected = _ref.rewardTypeSelected,
    claimInProgress = _ref.claimInProgress,
    initiateWorkflow = _ref.initiateWorkflow,
    isKycCompleted = _ref.isKycCompleted,
    isUpdateWorkflow = _ref.isUpdateWorkflow,
    checkBankVerificationStatus = _ref.checkBankVerificationStatus,
    loading = _ref.loading,
    checkKycVerificationStatus = _ref.checkKycVerificationStatus,
    setOpenKYCModal = _ref.setOpenKYCModal,
    cashOutFlow = _ref.cashOutFlow,
    setClaimInProgress = _ref.setClaimInProgress,
    fromRewardForm = _ref.fromRewardForm,
    bankstatus = _ref.bankstatus,
    isKycFailed = _ref.isKycFailed,
    isBankVerificationFailed = _ref.isBankVerificationFailed,
    isKycProcessing = _ref.isKycProcessing,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    config = _ref.config,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    cmsClient = _ref.cmsClient,
    isPoints = _ref.isPoints;
  var _useState = useState(isRewardsVisible ? true : false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showMessage = _useState4[0],
    setShowMessage = _useState4[1];
  var history = router === null || router === void 0 ? void 0 : router.history;

  // console.log("isKYCPRocessing inside KYC Modal", isKycProcessing);

  useEffect(function () {
    var _history$location;
    if (history !== null && history !== void 0 && history.replace && history !== null && history !== void 0 && (_history$location = history.location) !== null && _history$location !== void 0 && _history$location.pathname) {
      history.replace({
        pathname: history.location.pathname
      });
    }
  }, [history]);
  var totalPoints = isPoints ? Number((userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) || 0) : Number((userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission) + (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.rewardPoints));
  // console.log("Cashout Flow", cashOutFlow);
  // console.log("Total Points inside KYC MODAL" , totalPoints);

  var conditionalComponent = function conditionalComponent() {
    if ((isNaN(parseInt(userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission)) || !parseInt(userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission)) && cashOutFlow || totalPoints === 0 && !cashOutFlow) {
      return /*#__PURE__*/_jsx(ThirdStep, {
        loading: loading,
        nothingToClaim: true,
        closeUploadBox: closeKYCModal,
        router: router,
        config: config
      });
    }
    switch (step) {
      case 0:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end mr-4 mt-3",
            children: /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "h-4 w-4 cursor-pointer"
            })
          }), /*#__PURE__*/_jsx(FirstStep, {
            closeKYCModal: closeKYCModal,
            setStep: setStep,
            loading: loading,
            checkKycVerificationStatus: checkKycVerificationStatus,
            error: error,
            setOpenUploadBox: setOpenKYCModal,
            initiateWorkflow: initiateWorkflow
          })]
        });
      case 1:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex ".concat(isUpdateWorkflow ? "justify-between" : "justify-end", " "),
            children: [isUpdateWorkflow && /*#__PURE__*/_jsxs("div", {
              className: "flex items-center ml-3 cursor-pointer",
              onClick: function onClick() {
                return setStep(3);
              },
              children: [" ", /*#__PURE__*/_jsx(MdArrowBack, {}), " ", /*#__PURE__*/_jsx("button", {
                className: "ml-1",
                children: "Go Back"
              })]
            }), /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
            })]
          }), /*#__PURE__*/_jsx(SecondStep, {
            loading: loading,
            isUpdateWorkflow: isUpdateWorkflow,
            initiateWorkflow: initiateWorkflow,
            closeUploadBox: closeKYCModal,
            isKycCompleted: isKycCompleted,
            setStep: setStep,
            cashOutFlow: cashOutFlow,
            isKycFailed: isKycFailed,
            isBankVerificationFailed: isBankVerificationFailed,
            isKycProcessing: isKycProcessing,
            router: router,
            config: config
          })]
        });
      case 2:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end",
            children: /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
            })
          }), /*#__PURE__*/_jsx(ThirdStep, {
            loading: loading,
            claimInProgress: claimInProgress,
            setClaimInProgress: setClaimInProgress,
            fromRewardForm: fromRewardForm,
            closeUploadBox: closeKYCModal,
            isKycProcessing: isKycProcessing,
            router: router,
            config: config
          })]
        });
      case 3:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end pr-3 md:pr-4 pt-3",
            children: show && /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
            })
          }), /*#__PURE__*/_jsx(MiniSurvey, {
            show: show,
            setShow: setShow,
            closeKYCModal: closeKYCModal,
            showMessage: showMessage,
            setShowMessage: setShowMessage,
            bankstatus: bankstatus,
            config: config,
            winnreAuth: winnreAuth
          }), !show && /*#__PURE__*/_jsxs(_Fragment, {
            children: [!rewardTypeSelected && /*#__PURE__*/_jsxs("div", {
              className: "flex justify-between pl-3 md:pl-8 pr-2 pt-4",
              children: [/*#__PURE__*/_jsx("h2", {
                className: " font-Poppins font-bold text-lg ",
                children: "Confirm your details"
              }), !show && /*#__PURE__*/_jsx(GrClose, {
                onClick: closeKYCModal,
                className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
              })]
            }), /*#__PURE__*/_jsx(FourthStep, {
              setClaimInProgress: setClaimInProgress,
              checkKycVerificationStatus: checkKycVerificationStatus,
              claimInProgress: claimInProgress,
              checkBankVerificationStatus: checkBankVerificationStatus,
              getUserAccountSummary: getUserAccountSummary,
              setStep: setStep,
              rewardTypeSelected: rewardTypeSelected,
              closeKYCModal: closeKYCModal,
              winnreAuth: winnreAuth
            })]
          })]
        });
      case 4:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex justify-between pl-3 md:pl-8 pr-3 pt-4",
            children: [/*#__PURE__*/_jsx(BsArrowLeft, {
              className: "text-black w-6 h-full cursor-pointer",
              onClick: function onClick() {
                return setStep(0);
              }
            }), /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-2"
            })]
          }), /*#__PURE__*/_jsx(FifthStep, {
            userAccountSummary: userAccountSummary,
            getUserAccountSummary: getUserAccountSummary,
            setStep: setStep,
            setOpenKYCModal: setOpenKYCModal,
            closeKYCModal: closeKYCModal,
            initiateWorkflow: initiateWorkflow,
            bankstatus: bankstatus
          })]
        });
      case 5:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end",
            children: /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
            })
          }), /*#__PURE__*/_jsx(SixthStep, {
            setStep: setStep,
            winnreAuth: winnreAuth
          })]
        });
      case 6:
        return /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(SeventhStep, {
            setStep: setStep,
            isKycFailed: isKycFailed,
            isBankVerificationFailed: isBankVerificationFailed
          })
        });
      case 7:
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "flex justify-end",
            children: /*#__PURE__*/_jsx(GrClose, {
              onClick: closeKYCModal,
              className: "md:self-center h-4 w-4 cursor-pointer mr-3 "
            })
          }), /*#__PURE__*/_jsx(EightStep, {
            setStep: setStep,
            closeKYCModal: closeKYCModal,
            router: router,
            isPoints: isPoints
          })]
        });
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    visible: visible,
    onClick: onClick,
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(step === 0 || step === 3 ? "overflow-y-scroll scrollbar-thin ".concat(step === 0 ? "h-[80vh] " : "h-[90vh]") : "", " ").concat(step === 3 && show && showMessage ? "md:h-auto" : step === 3 && show && !showMessage || step === 0 ? "md:h-[80vh]" : "md:h-auto")
      //  ${step === 3 && show  ? 'md:h-[90vh]' : ''}`}
      ,
      children: conditionalComponent(step)
    }), showError && /*#__PURE__*/_jsx("div", {
      "class": "alert alert-error w-[80%] animate-pulse mx-auto h-auto mb-2 ",
      children: /*#__PURE__*/_jsx("label", {
        children: error
      })
    })]
  });
}
export default KYCModal;